import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getWalkinQueueSnapshot(salonId, token) {
  const res = await axios.get(`${API}/salons/${salonId}/walkin-queue/session/active`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function startWalkinQueueSession(salonId, payload, token) {
  const res = await axios.post(
    `${API}/salons/${salonId}/walkin-queue/session/start`,
    payload || {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function pauseWalkinQueueSession(salonId, token) {
  const res = await axios.post(
    `${API}/salons/${salonId}/walkin-queue/session/pause`,
    {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function resumeWalkinQueueSession(salonId, token) {
  const res = await axios.post(
    `${API}/salons/${salonId}/walkin-queue/session/resume`,
    {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function endWalkinQueueSession(salonId, token) {
  const res = await axios.post(
    `${API}/salons/${salonId}/walkin-queue/session/end`,
    {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function updateWalkinQueueSessionSettings(salonId, payload, token) {
  const res = await axios.patch(
    `${API}/salons/${salonId}/walkin-queue/session/settings`,
    payload || {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function listWalkinQueueMembers(salonId, token) {
  const res = await axios.get(`${API}/salons/${salonId}/walkin-queue/members`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function addWalkinQueueMember(salonId, payload, token) {
  const res = await axios.post(
    `${API}/salons/${salonId}/walkin-queue/members`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function updateWalkinQueueMember(salonId, memberId, payload, token) {
  const res = await axios.patch(
    `${API}/salons/${salonId}/walkin-queue/members/${memberId}`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function deleteWalkinQueueMember(salonId, memberId, token) {
  const res = await axios.delete(
    `${API}/salons/${salonId}/walkin-queue/members/${memberId}`,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function reorderWalkinQueueMembers(salonId, payload, token) {
  const res = await axios.post(
    `${API}/salons/${salonId}/walkin-queue/members/reorder`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function assignWalkin(salonId, payload, token) {
  const res = await axios.post(
    `${API}/salons/${salonId}/walkin-queue/assign`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function previewWalkinEligibility(salonId, payload, token) {
  const res = await axios.post(
    `${API}/salons/${salonId}/walkin-queue/eligibility/preview`,
    payload || {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function listWalkinQueueLogs(salonId, params, token) {
  const res = await axios.get(`${API}/salons/${salonId}/walkin-queue/logs`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getWalkinQueueReportSummary(salonId, params, token) {
  const res = await axios.get(`${API}/salons/${salonId}/walkin-queue/report/summary`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getWalkinQueueSettings(salonId, token) {
  const res = await axios.get(`${API}/salons/${salonId}/walkin-queue/settings`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateWalkinQueueSettings(salonId, payload, token) {
  const res = await axios.patch(
    `${API}/salons/${salonId}/walkin-queue/settings`,
    payload || {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function syncWalkinQueueMembersFromSchedule(salonId, payload, token) {
  const res = await axios.post(
    `${API}/salons/${salonId}/walkin-queue/members/sync-from-schedule`,
    payload || {},
    { headers: authHeaders(token) }
  );
  return res.data;
}
